module.exports = __webpack_public_path__ + "static/img/banner3.7177ad3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/banner3.png
// module id = IoVk
// module chunks = 0